/* eslint-disable react-hooks/exhaustive-deps */
import React, { useState, useEffect, useContext } from 'react';
import AsyncSelect from 'react-select/async';
import Select from 'react-select';
import 'react-toastify/dist/ReactToastify.css';
import Swal from 'sweetalert2';
import { getGetRequestOptions } from "../components/GetToken";
import { AppContext } from '../context/AppContext';
import validationMessage from '../helpers/ValidationErrorMsg'

const customStylesSelect = {
    control: (provided) => ({
        ...provided,
        height: 'calc(1.35em + 1.1rem + 2px)',
        minHeight: '35px'
    }),
    valueContainer: (provided) => ({
        ...provided,
    })
};

const LogBookFuelCreate = ({ project, logDate, equipment, onClose, onLogCreated }) => {
    const { jwt } = useContext(AppContext);
    const [allBusinessUnits, setAllBusinessUnits] = useState([]);
    const [state, setState] = useState({
        logBookBusinessUnit: "",
        projectId: "",
        equipment: null,
        fuelType: "",
        tankCapacity: "",
        fuelQty: "",
        refuelingDate: "",
        previousHrsMeter: "",
        currentHrsMeter: ""
    });
    const [vehicleSearchKey, setVehicleSearchKey] = useState(0);

    useEffect(() => {
        getAllBu();
    }, []);

    useEffect(() => {
        if (project) {
            setState(prev => ({
                ...prev,
                logBookBusinessUnit: project,
                projectId: project.projectId
            }));
        }
        if (logDate) {
            setState(prev => ({
                ...prev,
                refuelingDate: logDate
            }));
        }
    }, [project, logDate]);

    // Load equipment info when specific props are available
    useEffect(() => {
        const loadEquipmentFromId = async () => {
            if (equipment && equipment.equipmentId && state.logBookBusinessUnit?.projectId) {
                const allEquipment = await fetchEquipment(equipment.equipmentCode);
                const selectedEquipment = allEquipment.find(e => e.equipmentId === equipment.equipmentId);
                if (selectedEquipment) {
                    setState(prev => ({
                        ...prev,
                        equipment: selectedEquipment,
                        fuelType: selectedEquipment.fuelType || "",
                        tankCapacity: selectedEquipment.tankCapacity || "",
                        previousHrsMeter: selectedEquipment.previousHrsMeter || "",
                        emoDetailsId: selectedEquipment.emoDetailsId || ""
                    }));
                    setVehicleSearchKey(prev => prev + 1);
                }
            }
        };

        loadEquipmentFromId();
    }, [equipment, state.logBookBusinessUnit?.projectId]);

    const getAllBu = () => {
        fetch(process.env.REACT_APP_API_URL + "get_user_business_units", getGetRequestOptions())
            .then((resp) => resp.json())
            .then((resp) => {
                let tempResp = resp.data.map(function (element) {
                    return {
                        ...element,
                        label: element.projectName,
                        value: element.projectId,
                        isdisabled: element.projectName === 'EMD' ? false : true
                    }
                });
                setAllBusinessUnits(tempResp);
            })
            .catch((error) => {
                console.log(error);
            });
    }

    const getEquipment = (inputValue, callback) => {
        if (!state.logBookBusinessUnit || !state.logBookBusinessUnit.projectId) {
            callback([]);
            return;
        }
        let url = `${process.env.REACT_APP_API_URL}equipment/received_equipment_search/${state.logBookBusinessUnit.projectId}`;
        if (inputValue) {
            url += `?q=${inputValue}`;
        }
        fetch(url, getGetRequestOptions())
            .then(resp => resp.json())
            .then(resp => {
                const options = resp.data.map(element => ({
                    ...element,
                    label: `${element.equipmentName} (${element.equipmentCode})`,
                    value: element.equipmentId
                }));
                callback(options);
            })
            .catch(error => console.log(error));
    }

    const fetchEquipment = async (inputValue = "") => {
        if (!state.logBookBusinessUnit || !state.logBookBusinessUnit.projectId) return [];
        let url = `${process.env.REACT_APP_API_URL}equipment/received_equipment_search/${state.logBookBusinessUnit.projectId}`;
        if (inputValue) url += `?q=${inputValue}`;

        try {
            const resp = await fetch(url, getGetRequestOptions());
            const data = await resp.json();
            return data.data.map(element => ({
                ...element,
                label: `${element.equipmentName} (${element.equipmentCode})`,
                value: element.equipmentId
            }));
        } catch (error) {
            console.error("Error fetching equipment:", error);
            return [];
        }
    };

    const handleEquipmentChange = equipment => {
        setState(prev => ({
            ...prev,
            equipment,
            fuelType: equipment.fuelType || "",
            tankCapacity: equipment.tankCapacity || "",
            previousHrsMeter: equipment.previousHrsMeter || ""
        }));
    }

    const handleBuChange = logBookBusinessUnit => {
        setState(prev => ({
            ...prev,
            logBookBusinessUnit,
            projectId: logBookBusinessUnit.projectId,
            equipment: null,
            fuelType: "",
            tankCapacity: "",
            previousHrsMeter: ""
        }));
        setVehicleSearchKey(prevKey => prevKey + 1);
    }

    const handleInputOnChange = (name, value) => {
        setState(prev => ({ ...prev, [name]: value }));
    };

    const handleSubmit = evt => {
        evt.preventDefault();

        const formData = {
            projectId: state.projectId,
            equipment: state.equipment !== null ? state.equipment.value : null,
            fuelType: state.fuelType,
            tankCapacity: state.tankCapacity,
            fuelQty: state.fuelQty,
            refuelingDate: state.refuelingDate,
            previousHrsMeter: state.previousHrsMeter,
            hrsMeter: state.currentHrsMeter,
            emoDetailsId: state.equipment !== null ? state.equipment.emoDetailsId || "" : ""
        }

        Swal.fire({
            title: 'Are you sure?',
            text: "You want to entry this fuel log!",
            icon: 'warning',
            showCancelButton: true,
            confirmButtonText: 'Yes',
            cancelButtonText: 'No'
        }).then((result) => {
            if (result.value) {
                const requestOptions = {
                    method: 'POST',
                    headers: {
                        'Content-Type': 'application/json',
                        'Authorization': 'Bearer ' + jwt.token
                    },
                    body: JSON.stringify(formData)
                };

                fetch(process.env.REACT_APP_API_URL + "log_book/fuel_entry", requestOptions)
                    .then((resp) => resp.json())
                    .then((resp) => {
                        if (resp.success === true) {
                            Swal.fire({
                                icon: 'success',
                                title: 'Success',
                                text: resp.successMessage,
                            });
                            onLogCreated();
                        } else {
                            const errorsMessage = validationMessage(resp.errorMessage).join("<br>");
                            Swal.fire({
                                icon: 'error',
                                title: 'Error',
                                html: errorsMessage,
                            });
                        }
                    })
                    .catch((error) => {
                        console.log(error);
                        Swal.fire({
                            icon: 'error',
                            title: 'Error',
                            text: 'An error occurred while submitting the form',
                        });
                    });
            }
        });
    }

    return (
        <form onSubmit={handleSubmit}>
            <div className="card-body">
                <div className="ml-12">
                    <div className='row'>
                        <div className='col-12'>
                            <div className="form-group row">
                                <label className="col-lg-4 col-form-label text-right">Business Unit<span className="text-danger">*</span></label>
                                <div className="col-lg-6">
                                    <Select
                                        value={state.logBookBusinessUnit}
                                        onChange={handleBuChange}
                                        options={allBusinessUnits}
                                        styles={customStylesSelect}
                                    />
                                </div>
                            </div>
                            <div className="form-group row">
                                <label className="col-lg-4 col-form-label text-right">Equipment<span className="text-danger">*</span></label>
                                <div className="col-lg-6">
                                    <AsyncSelect
                                        key={vehicleSearchKey}
                                        isDisabled={!state.logBookBusinessUnit}
                                        value={state.equipment}
                                        defaultOptions
                                        loadOptions={getEquipment}
                                        placeholder="Select Equipment"
                                        onChange={handleEquipmentChange}
                                        styles={customStylesSelect}
                                    />
                                </div>
                            </div>
                            {/* Fuel Type */}
                            <div className="form-group row">
                                <label className="col-lg-4 col-form-label text-right">Fuel Type<span className="text-danger">*</span></label>
                                <div className="col-lg-6">
                                    <input type="text" value={state.fuelType} readOnly className="form-control" />
                                </div>
                            </div>
                            {/* Tank Capacity */}
                            <div className="form-group row">
                                <label className="col-lg-4 col-form-label text-right">Tank Capacity<span className="text-danger">*</span></label>
                                <div className="col-lg-6">
                                    <div className="input-group">
                                        <div className="input-group-prepend"><span className="input-group-text">L</span></div>
                                        <input type="text" value={state.tankCapacity} readOnly className="form-control" />
                                    </div>
                                </div>
                            </div>
                            {/* Fuel Quantity */}
                            <div className="form-group row">
                                <label className="col-lg-4 col-form-label text-right">Fuel Quantity<span className="text-danger">*</span></label>
                                <div className="col-lg-6">
                                    <div className="input-group">
                                        <div className="input-group-prepend"><span className="input-group-text">L</span></div>
                                        <input type="number" value={state.fuelQty} onChange={e => handleInputOnChange('fuelQty', e.target.value)} className="form-control" />
                                    </div>
                                </div>
                            </div>
                            {/* Refueling Date */}
                            <div className="form-group row">
                                <label className="col-lg-4 col-form-label text-right">Refueling Date<span className="text-danger">*</span></label>
                                <div className="col-lg-6">
                                    <input type="date" value={state.refuelingDate} onChange={e => handleInputOnChange('refuelingDate', e.target.value)} className="form-control" />
                                </div>
                            </div>
                            {/* Previous Hrs Meter */}
                            <div className="form-group row">
                                <label className="col-lg-4 col-form-label text-right">Previous Hrs Meter<span className="text-danger">*</span></label>
                                <div className="col-lg-6">
                                    <input type="number" value={state.previousHrsMeter} readOnly className="form-control" />
                                </div>
                            </div>
                            {/* Current Hrs Meter */}
                            <div className="form-group row">
                                <label className="col-lg-4 col-form-label text-right">Current Hrs Meter<span className="text-danger">*</span></label>
                                <div className="col-lg-6">
                                    <input type="number" value={state.currentHrsMeter} onChange={e => handleInputOnChange('currentHrsMeter', e.target.value)} className="form-control" />
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div className="card-footer">
                <div className="row">
                    <div className="col-6"></div>
                    <div className="col-6">
                        <button type="submit" className="btn btn-success mr-2">Submit</button>
                        <button type="reset" className="btn btn-secondary" onClick={onClose}>Cancel</button>
                    </div>
                </div>
            </div>
        </form>
    );
};

export default LogBookFuelCreate;
